import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';

// Confirmation step for a decision.
//
// Deliberately not a one-click action in the table: a decision cannot be taken back
// (deciding twice is rejected by the API, so the first answer is the final one), and a
// denial is worth a sentence explaining why for whoever reads the row later.
const DecisionModal = ({ request, approved, onCancel, onConfirm }) => {
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = () => {
    setSubmitting(true);
    setError('');
    Promise.resolve(onConfirm(note))
      .catch((failure) => {
        // A conflict means someone else got there first. Saying "try again" would be
        // wrong advice — the decision already exists and will not be overwritten.
        setError(
          failure?.response?.status === 409
            ? 'This request has already been decided, most likely by someone else. Close this and reload the list to see the decision.'
            : 'The decision could not be recorded. Please try again.'
        );
        setSubmitting(false);
      });
  };

  const accountLabel = request.account_name || request.account_email_address || 'this account';

  return (
    <Dialog open onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{approved ? 'Approve request' : 'Deny request'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {approved
            ? `Approving reopens self-service licence issuance for ${accountLabel}. The licence and any package are still granted separately, from the account page.`
            : `Denying leaves ${accountLabel} as it is, with self-service licence issuance closed. The account keeps working; it simply gets no licence.`}
        </DialogContentText>
        {error && <DialogContentText color="error">{error}</DialogContentText>}
        <TextField
          fullWidth
          multiline
          rows={3}
          margin="dense"
          label="Note (optional)"
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={submitting}
        >
          {submitting ? 'Recording…' : approved ? 'Approve' : 'Deny'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DecisionModal;
